import { useState, useEffect, useCallback } from 'react'

import { GoogleMapsOverlay as DeckOverlay } from '@deck.gl/google-maps';
import { GeoJsonLayer } from '@deck.gl/layers';
import { executeSQL } from "@carto/react-api";
import LoadingComponent from '../Loader'

const overlayStore = []

const formatDate = (date) => {
  return new Intl.DateTimeFormat('en-AU', {
    dateStyle: 'full',
    timeStyle: 'short'
  }).format(new Date(Date.parse(date)))
}

const ClosureDateItem = (props) => {
  // const [visibleDByDate, setVisibleByDate] = useState(false)

  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    month: "long",
    day: "numeric",
  }
  const date = new Date(props.date)
  const padDate = (date: number) => `00${(Number(date)).toString()}`.slice(-2)

  const colours = [
    [148, 0, 33, 200],
    [178, 90, 167, 200],
    [0, 0, 255, 255],
    // [255, 255, 0, 255],
    // [255, 0, 255, 255],
    // [0, 255, 255, 255]
  ]

  const [closuresState, setClosuresState] = useState([])
  const [closureGroups, setClosureGroups] = useState({})
  const [activeClosureGroup, setActiveClosureGroup] = useState(null)
  // const [selectedLayer, setSelectedLayer] = useState(0)
  // const [overlays, setOverlays] = useState([])
  let closureIds = []
  closureIds.length = 0

  const getCartoSQL = (instances, timestamp) => {
    const credentials = {
      username: "sopa",
      apiKey: "bb99135d7426b80172f9a9dda33d5f6e6ee1d7bb",
      // In dev, route the Carto SQL API through the dev-server proxy too (the
      // browser fetch to sopa.carto.com fails CORS even though curl gets ACAO:*).
      // See vite.config.ts ('/carto-api'). Prod hits Carto directly.
      serverUrlTemplate: import.meta.env.DEV
        ? `${new URL(import.meta.url).origin}/carto-api`
        : 'https://{user}.carto.com',
    };

    const opts = {
      format: 'geojson'
    }

    // Keep the query compact: the previous multi-line template literal added
    // newlines + deep indentation that, once URL-encoded alongside ~100+ keys,
    // pushed the GET URL past Carto's edge limit, returning a 400 (HTML) with no
    // CORS headers — which surfaced in the browser as a CORS error and stopped
    // the overlay from ever building. De-duplicate the keys for good measure.
    const uniqueInstances = [...new Set(instances)]
    const query = `SELECT * FROM sopa.sopa_road_segments_apr_8_2015 where key in (${uniqueInstances.join(',')})`;
    const fetchData = async () => {
      const result = await executeSQL({ credentials, query, opts })
      buildClosuresOverlay(result, timestamp)
      return result;
    };

    fetchData();
  }

  const closureInfo = (key: string) => {
    let roadClosure
    closuresState.forEach(instances => {
      instances.forEach(instance => {
        const layers = instance.ClosedFeatures
        for (let i in layers) {
          if (layers[i].featureId.toString() === key.toString()) {
            // setActiveClosureGroup(prevState => {
            //   let newState = prevState
            //   Object.keys(closureGroups).forEach(key => {
            //     closureGroups[key].forEach(group => {
            //       if (group.id.toString() === layers[i].featureId.toString()) {
            //         newState = key
            //       }
            //     })
            //   })
            //   return newState
            // })
            roadClosure = instance
          }
        }
      })
    });

    return `
    <div className="sopa--infobox">
      <p><strong>Closed due to:</strong><span> ${roadClosure.EventName}</span></p>
      <p>${roadClosure.ClosureDescription}</p>
      <p>From: ${formatDate(roadClosure.StartDateTime)}
      <br>To: ${formatDate(roadClosure.EndDateTime)}</p>
    </div>
    `
  }

  const onClick = useCallback(info => {
    handleClick(info)
  }, [])


  const handleClick = info => {
    // console.log('Clicked:', info, overlayStore);
    if (info.index > -1) {
      // the user has clicked on a layer with data in it (a road closure)
      //info.layer.id = selectedLayer
      // console.log('info: ', info.layer.id, info.object.properties.key, closureGroups)
      closureIds.length = 0
      const layerIdPartial = info.layer.id.toString().replace('road_closures_', '').split('_')[0]
      const closureKeys = Object.keys(closureGroups)
      if (closureKeys.includes(layerIdPartial)) {
        // the layer correctly matches an available group of layers
        // let's not yet dwell on what happens if this is never true
        closureGroups[layerIdPartial].forEach(k => {
          closureIds.push(k.id)
        })
      }
      // console.log('my groups are now s: ', closureGroups, closureIds, overlayStore[0].props.layers)

      const closureContent = closureInfo(info.object.properties.key)
      // setSelectedLayer(info.object.properties.key)
      props.setClosureDetails(closureContent)
      props.setClosureActive(true)
      // const date = Date.now()

//       const nl = info.layer.clone({
//         id: `${info.layer.id}_test`,
//         // visible: false,
//         getLineColor: f => {
//           console.log('f2: ', f.properties.key, closureIds, closureIds.includes(f.properties.key))
//           // if f.properties.key is part of the array that is in the info_layer_id then we can matchy match
//           // if (!props.closureActive) return colours[0]
//           if (closureIds.includes(f.properties.key)) {
//             return colours[2]
//           }
//           return colours[1]
//         },
//         // updateTriggers: {
//         //   visible: [props.checked],
//         //   // getLineColor: [closureIds, selectedLayer, props.closureActive]
//         // }
//       })
// console.log('nl: ', nl)

      // console.log('cl: ', closureLayers.length, closureGroups, closureLayers)
      // // if (closureLayers.length) {
        // const newLayers = []
        // overlayStore[0].props.layers.forEach((layer, idx) => {
        //   console.log('layer: ', layer.props)
        //   const nlp = {...layer.props}
        //   const cl = layer
        //   let clid = cl.id
        //   if (clid && clid.lastIndexOf('_') < 20 ) {
        //     // initial construct, with no date attached
        //     clid = `${clid}_${date}`
        //   } else {
        //     clid = `${clid.slice(clid.lastIndexOf('_'))}_${date}`
        //   }

        //   nlp.lineCapRounded = false
        //   newLayers.push(
        //     //nlp
        //     // cl.props.clone({
        //     //   id: clid,
        //     //   getLineColor: f => {
        //     //     console.log('f2: ', f.properties.key, closureIds, closureIds.includes(f.properties.key))
        //     //     // if f.properties.key is part of the array that is in the info_layer_id then we can matchy match
        //     //     // if (!props.closureActive) return colours[0]
        //     //     if (closureIds.includes(f.properties.key)) {
        //     //       return colours[1]
        //     //     }
        //     //     return colours[0]
        //     //   },
        //     //   // updateTriggers: {
        //     //   //   visible: [props.checked],
        //     //   //   // getLineColor: [closureIds, selectedLayer, props.closureActive]
        //     //   // }
        //     // })
        //   )
        // })

      // overlayStore.forEach((co) => {
      //   co.setMap(null)
      //   co.finalize()
      // })
      // overlay.setProps({
      //   layers: nl,
      // })
      // overlay.setMap(props.map)
      // overlayStore.push(overlay)
    }
  };

  let closureLayers = []

  const overlay = new DeckOverlay({
    onClick,
})

const buildClosuresOverlay = (instances, timestamp) => {
    const filtered = []
    Object.keys(closureGroups).forEach((key, idx) => {
      // instances has list of geometry measurements
      // filter that to only use features where the properties.id matches an id in te closure group
      // we're inside a closure group already, so filter instances by group object id

      filtered[idx] = structuredClone(instances)
      filtered[idx].features = instances.features.filter(inst => {
        return closureGroups[key].some(r => r.id === inst.properties.key)
      })

      closureLayers.push(
        new GeoJsonLayer({
          id: `road_closures_${key}`,
          data: filtered[idx],
          lineWidthScale: 10,
          lineWidthMinPixels: 5,
          lineWidthMaxPixels: 60,
          lineCapRounded: true,
          // getColor: [148, 0, 33, 200],
          getLineColor: f => {
            // console.log('f1: ', f, timestamp, date.getTime() / 1000, f.properties.key, closureIds, closureIds.includes(f.properties.key), props.checked && (date.getTime() / 1000).toString() === timestamp)
            return colours[0]
          },
          pickable: true,
          autoHighlight: true,
          highlightColor: colours[5],
          updateTriggers: {
            visible: [props.checked],
            // getLineColor: [closureIds, selectedLayer, props.closureActive],
          },
          visible: props.checked && String((date.getTime() / 1000)) === timestamp,
        })
      )
    })

    overlay.setProps({
      layers: [...closureLayers]
    })
    overlay.setMap(props.map)
    overlayStore.push(overlay)
  }

  const getDataForDay = timestamp => {
    // remove an existing overlay, should one exist
    overlayStore.forEach((co) => {
      co.setMap(null)
      co.finalize()
    })

    overlayStore.length = 0

    async function getClosures() {
      const UrlDate = date.getFullYear() + '-' + padDate(date.getMonth() + 1) + '-' + padDate(date.getDate())
      const response = await fetch(`${props.datesURL.base}${props.datesURL.day}${UrlDate}${props.datesURL.published}`);

      const closuresRes = await response.json();
      if (closuresRes.length) {
        const instances = []
        let closureGroupKey: string|null  = null
        closuresRes.forEach(res => {
          const feat = res.ClosedFeatures;
          if (!feat) return
          closureGroupKey  = res.Key
          const closureGroupItems = []
          for (let i in feat) {
            instances.push(`'${feat[i].featureId}'`)
            closureGroupItems.push({
              id: feat[i].featureId,
              layerId: feat[i].layerId,
            })
          }
          setClosureGroups((prevState) => {
            const newState = prevState
            if (closureGroupKey !== null) {
              newState[closureGroupKey] = closureGroupItems
            }
            return newState
          })
        })
        getCartoSQL(instances, timestamp)
      }
      setClosuresState((prevstate) => {
        const newState = prevstate
        newState.push(closuresRes)
        return newState
      })
    }

    getClosures()
  }

  const theDay = new Intl.DateTimeFormat("en-AU", options).format(date)

  const handleChange = event => {
    const { date } = event.target.dataset
    // setVisibleByDate(event.target.checked)
    // console.log('ts: ', date, event)
    props.setClosureActive(false)
    getDataForDay(date)
  }

  return (
    <label>
      <input
        name="road_closures"
        value={theDay}
        onChange={handleChange}
        data-date={Math.round(date.getTime() / 1000)}
        type="radio" />
      {theDay}
      <span className="nsw-material-icons material-icons"
        aria-hidden={'true'}>radio_button_unchecked</span>
      <span className="nsw-material-icons material-icons"
        aria-hidden={'true'}>radio_button_checked</span>
    </label>
  )
}

const ClosureDates = (props) => {
  const todayDateTime = new Date()
  const currentMonth = todayDateTime.getMonth()
  const currentYear = todayDateTime.getFullYear()
  const todayDate = new Date(currentYear, currentMonth, todayDateTime.getDate())

  const [startDates, setStartDates] = useState(new Set())
  const [monthParams, setMonthParams] = useState({
    year: currentYear,
    month: (currentMonth + 1)
  })
  const [moreDates, setMoreDates] = useState(true)
  const [loading, setLoading] = useState(true)

  const padDate = (date: number) => `00${(Number(date)).toString()}`.slice(-2)

  const convertDate = (date) => {
    if (date.indexOf('/') === -1) return false
    const dateParts = date.split("/");
    return new Date(+dateParts[0], Number(dateParts[1]) - 1, +dateParts[2]);
  }

  const datesURL = {
    prefix: '',
    // In dev (vite dev server) the appspot API's prod-only CORS allowlist blocks
    // *.ddev.site, so route through the dev-server proxy (see vite.config.ts).
    // Modules are served from :5173 while the page is on :443, so a bare relative
    // path would hit Drupal — target the dev-server origin explicitly.
    // In a production build this resolves to the appspot API directly.
    base: import.meta.env.DEV
      ? `${new URL(import.meta.url).origin}/closures-api/`
      : 'https://sopagru-dot-sopamap.appspot.com/',
    month: 'getclosuresbymonth?month=', //?month=2023-08&published=true'
    day: 'getclosuresbyday?startDay=', //?startDay=2023-08-27&published=true
    published: '&published=true'
  }

  const incrementDateForURL = () => {
    setMonthParams((prevState) => {
      const newState = prevState
      newState.month = Number(padDate(Number(prevState.month) + 1))
      if (newState.month === 13) {
        newState.month = Number(`01`)
        newState.year = prevState.year + 1
      }
      return newState
    })
  }

  const loadMoreDates = (event) => {
    event.preventDefault()
    incrementDateForURL()
    setMoreDates(false)
  }

  const setDates = dates => {
    setStartDates((prevState) => {
      const newState = prevState
      dates.forEach((item) => {
        let date = convertDate(item.startTime)
        const endDate = convertDate(item.endTime)
        while (date.getTime() <= endDate.getTime()) {
          // make sure we're only sending future dates to the component.

          //TODO turn this comment off before committing, so we can re-lock the dates.
          if (todayDate.getTime() <= date.getTime()) {
            newState.add(date.getTime())
          }

          date.setDate(date.getDate() + 1)
        }
      })
      if (newState.length < 3 && (monthParams.month) == currentMonth + 1) {
        incrementDateForURL()
        setMoreDates(false)
      }
      return newState
    })
  }

  useEffect(() => {
    overlayStore.forEach(overlay => {
      overlay.setMap(props.checked ? props.map : null)
    })
    if (!props.checked) {
      overlayStore.length = 0
      props.setShowDates(false)
    }
  }, [props.checked, props.closureActive])

  useEffect(() => {
    // React advises to declare the async function directly inside useEffect
    async function getDates() {

      setLoading(true)

      const response = await fetch(`${datesURL.base}${datesURL.month}${monthParams.year}-${padDate(monthParams.month)}${datesURL.published}`);

      const dates = await response.json();

      setLoading(false)
      setDates(dates)
    }

    getDates();
  }, [monthParams.month])

  return (
    <div className="sopa--map-closure-dates">
      <strong>Subject to change at short notice</strong>
      <fieldset>
        {Array.from(startDates).map((value, idx) => {
          return <ClosureDateItem checked={props.checked} map={props.map} setClosureActive={props.setClosureActive} closureActive={props.closureActive} setClosureDetails={props.setClosureDetails} padDate={padDate} datesURL={datesURL}
            date={value} key={`${idx}-${value}`} />
        })}
        {loading && <LoadingComponent classes={"invert"}
          message={"Getting road closure data"} />}
      </fieldset>
        <div className="sopa--map-closure-dates_load-more">
          {moreDates && <a href="#" onClick={loadMoreDates}>Load more</a>}
          {!moreDates && <em>There are no more dates to load</em>}
        </div>
      </div>
  )
}

export default ClosureDates
